import { BrandArrow, type BrandArrowKind } from './site/BrandArrow';

const ARROWS: BrandArrowKind[] = ['people', 'communities', 'world', 'sun'];
const DELAYS = ['', 'animation-delay-100', 'animation-delay-200', 'animation-delay-300'];

/** Branded loader (PRP-15): the logo's four arrows rise in turn. */
export const PageLoader = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
    <div className="flex items-end gap-2" aria-hidden="true">
      {ARROWS.map((kind, i) => (
        <BrandArrow key={kind} kind={kind} size="h-8" loading="eager" className={`animate-bounce ${DELAYS[i]}`} />
      ))}
    </div>
    <p className="text-muted text-sm font-medium">Loading...</p>
  </div>
);
